import axios from "axios";

export const AxiosCustomGet = (url, config, callback, errorCallback, finallyCallback) => {
    axios.get(url, config).then(response => {
        if (callback) callback(response);
    }).catch(error => {
        AxiosCustomError(error, errorCallback, finallyCallback);
    }).finally(() => {
        if (finallyCallback) finallyCallback();
    });
};

export const AxiosCustomPost = (url, data, config, callback, errorCallback, finallyCallback) => {
    axios.post(url, data, config).then(response => {
        if (callback) callback(response);
    }).catch(error => {
        AxiosCustomError(error, errorCallback, finallyCallback);
    }).finally(() => {
        if (finallyCallback) finallyCallback();
    });
};

export const AxiosCustomPut = (url, data, config, callback, errorCallback, finallyCallback) => {
    axios.put(url, data, config).then(response => {
        if (callback) callback(response);
    }).catch(error => {
        AxiosCustomError(error, errorCallback, finallyCallback);
    }).finally(() => {
        if (finallyCallback) finallyCallback();
    });
};

export const AxiosCustomDelete = (url, config, callback, errorCallback, finallyCallback) => {
    axios.delete(url, config).then(response => {
        if (callback) callback(response);
    }).catch(error => {
        AxiosCustomError(error, errorCallback, finallyCallback);
    }).finally(() => {
        if (finallyCallback) finallyCallback();
    });
};

const AxiosCustomError = (error, errorCallback, finallyCallback) => {
    // --- refresh token flow moved to interceptor.js ---
    if (errorCallback) errorCallback(error);
}